<!--
 * @Author: dqq
 * @Date: 2021-10-29 14:00:49
 * @LastEditTime: 2021-11-30 11:14:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dsicm-admin-web\src\views\decisionPage\leftModule\leftModule.vue
-->
<template>
  <div class="leftModuleBox">
    <div class="navBox">
      <div class="navItem" :class="navIndex==index?'cur':''" v-for="(item,index) in navTabArr" :key="index"
        @click="navTab(index)">
        {{item.name}} <span class="smallFonts" v-if="navIndex==index">{{item.miniTitle}}</span>
      </div>
    </div>

    <!-- 术语模块 -->
    <div class="onomastion">
      <el-scrollbar style="height:100%">
        <!-- 基本信息 -->
        <div class="content-wrap">
          <div class="message-box">
            <collapse :titleType="'headline'" titleName="基本信息">
              <div>
                <div class="search-box">
                  <el-form :inline="true" class="demo-form-inline" size="mini">
                    <el-form-item>
                      <el-input placeholder="请输入关键字搜索" @clear="clearInfo" @input="searchChange"
                        prefix-icon="el-icon-search" clearable v-model="searchResultInfo">
                      </el-input>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="message-item-box" v-for="(item,index) in basicInformation" :key="index">

                  <collapse :titleType="'subheading'" :titleName="item.name">
                    <!-- 二级展示:拖入子集 -->
                    <div class="message-content-box" v-if="item.name=='医疗诊断' || item.name =='身份信息' || item.name =='症状' || item.name =='标签'">
                      <span :class="el.isSlect ? 'curOne-sign active' : 'curOne-sign'"
                        v-for="(el,indexs) in item.children" :key="indexs"
                        @click="slideFun(index,indexs,el,item)">{{el.fieldName}}</span>
                    </div>
                    <!-- 一级直接拖入元素 -->
                    <div class="message-content-box mmm" v-else>
                      <span :class="el.isSlect? 'curTwo-sign active' : 'curTwo-sign'" draggable
                        @dragstart="(e)=>{dragstart(e,el)}" v-for="(el,indexs) in item.children"
                        :key="indexs">{{el.fieldName}}</span>
                    </div>
                  </collapse>
                </div>
              </div>
            </collapse>
          </div>
        </div>
        <!-- 问卷 -->
        <div class="content-wrap">
          <div class="message-box">
            <collapse :titleType="'headline'" titleName="问卷">
              <div>
                <div class="search-box">
                  <el-form :inline="true" class="demo-form-inline" size="mini">
                    <el-form-item>
                      <el-input placeholder="请输入关键字搜索" @input="searchChangeQuest" prefix-icon="el-icon-search" clearable
                        v-model="questionnaireName">
                      </el-input>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="message-item-box" v-for="(item,index) in questionnaire" :key="index">

                  <collapse :titleType="'subheading'" :titleName="item.name">
                    <div class="message-content-box">
                      <span :class="el.isSlect? 'curTwo-sign active' : 'curTwo-sign'"
                        v-for="(el,indexs) in item.children" :key="indexs" draggable
                        @dragstart="(e)=>{dragstart(e,el)}">{{el.fieldName}}</span>
                    </div>
                  </collapse>
                </div>
              </div>
            </collapse>
          </div>
        </div>
        <!-- 条件 -->
        <div class="condition">
          <div class="condition_title">
            条件
          </div>
          <div class="condition_item" v-for="(el,index_) in conditionArr" :key="index_">
            <div class="condition_item_name">
              {{el.name}}
            </div>
            <div class="selectBox_s" draggable @dragstart="(e)=>{dragstart(e,el)}">
              <div v-for="(el_item,el_index) in el.children" :key="el_index">
                <select class="selectBox" v-if="el_item.showType=='select_greater'" v-model="el_item.operator">
                  <option :value="item.val" v-for="(item,index) in $defaultData.symbolArr" :key="index">{{item.label}}
                  </option>
                </select>
                <div class="numberLast" v-if="el_item.showType=='button_last'">最后</div>
                <input v-if="el_item.showType=='input'" type="text" maxlength="6"
                  oninput="value=value.replace(/(\..*)\..*/, '$1').replace(/[^0-9\.]/g, '');if(value>999.99)value=999.99"
                  class="inputBox" placeholder="数值0～999.99" v-model="el_item.value">
                <select class="selectBox" v-if="el_item.showType=='select_time'" v-model="el_item.valueUnit">
                  <option :value="item.val" v-for="(item,index) in $defaultData.hourlyBasis" :key="index">{{item.label}}
                  </option>
                </select>
                <select class="selectBox" v-if="el_item.showType=='select_time_direction'" v-model="el_item.operator">
                  <option :value="item.val" v-for="(item,index) in $defaultData.aroundBasis" :key="index">{{item.label}}
                  </option>
                </select>
                <select class="selectBox" v-if="el_item.showType=='select_time_longness'" v-model="el_item.valueUnit">
                  <option :value="item.val" v-for="(item,index) in $defaultData.qualitative" :key="index">{{item.label}}
                  </option>
                </select>
                <select class="selectBox" v-if="el_item.showType=='select_symbol'" v-model="el_item.value">
                  <option :value="item.label" v-for="(item,index) in $defaultData.determineArr" :key="index">
                    {{item.label}}</option>
                </select>
                <select class="selectBox" v-if="el_item.showType=='select_bool'" v-model="el_item.operator">
                  <option :value="item.val" v-for="(item,index) in $defaultData.absoluteType" :key="index">
                    {{item.label}}</option>
                </select>
                <select class="selectBox" v-if="el_item.showType=='select_number'" v-model="el_item.value">
                  <option :value="item.val" v-for="(item,index) in $defaultData.timeArr" :key="index">{{item.label}}
                  </option>
                </select>

                <div class="numberTimes" v-if="el_item.showType=='button'">次</div>
                <input v-if="el_item.showType=='input_number'" type="number" class="inputBox" placeholder="请输入数值"
                  v-model="el_item.value">
                <select class="selectBox" v-if="el_item.showType=='select_button'">
                  <option :value="item.val" v-for="(item,index) in $defaultData.numArr" :key="index">{{item.label}}
                  </option>
                </select>
              </div>

            </div>
          </div>

        </div>
      </el-scrollbar>
    </div>
    <!-- 只有一级的左边子菜单 前面6个 -->
    <div class="secondary-box-one" v-if="secondLevelShow">
      <div class="searchBox">
        <el-input class="searchBox_input" @input="searchFilter" v-model="illnessType" size="mini" placeholder="请输入关键字搜索"
          @clear="clearInfoIllness" prefix-icon="el-icon-search" clearable>
        </el-input>
      </div>
      <div class="box_item">
        <el-scrollbar style="height:100%">
          <div class="message-item-box">
            <div class="message-content-box">
              <span :class="indexs == 0 ? 'curOne-sign' : 'curOne-sign'" v-for="(el,indexs) in DiseaseTypeList"
                :key="indexs" draggable @dragstart="(e)=>{dragstart(e,el)}">{{el.fieldName}}</span>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <!-- 只有一级的左边子菜单 打卡用药 -->
    <div class="secondary-box-two" v-if="secondLevelDrugShow">
      <div class="searchBox">
        <el-input class="searchBox_input" size="mini" placeholder="请输入关键字搜索" prefix-icon="el-icon-search" clearable
          v-model="searchResultOne" @input="searchGetMedication">
        </el-input>
      </div>
      <div class="box_item">
        <el-scrollbar
          style="height:100%">
          <div class="message-item-box">
            <div class="message-content-box">
              <span :class="indexs == 0 ? 'curOne-sign' : 'curOne-sign'" v-for="(el,indexs) in drugList" :key="indexs"
                draggable @dragstart="(e)=>{dragstart(e,el)}">{{el.fieldName}}</span>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div class="pagination">
        <el-pagination small background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="searchForm.current" :page-size="searchForm.size"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 只有一级的左边子菜单 症状 -->
    <div class="secondary-box-two" v-if="secondSymptomShow">
      <div class="searchBox">
        <el-input class="searchBox_input" size="mini" placeholder="请输入关键字搜索" prefix-icon="el-icon-search" clearable
          v-model="searchResultOneSymptom" @input="searchGetMedicationSymptom">
        </el-input>
      </div>
      <div class="box_item">
        <el-scrollbar
          style="height:100%">
          <div class="message-item-box">
            <div class="message-content-box">
              <span :class="indexs == 0 ? 'curOne-sign' : 'curOne-sign'" v-for="(el,indexs) in drugListSymptom" :key="indexs"
                draggable @dragstart="(e)=>{dragstart(e,el)}">{{el.fieldName}}</span>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div class="pagination">
        <el-pagination small background @size-change="handleSizeChangeSymptom" @current-change="handleCurrentChangeSymptom"
          :current-page.sync="searchFormSymptom.current" :page-size="searchFormSymptom.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalSymptom">
        </el-pagination>
      </div>
    </div>
    <!-- 只有一级的左边子菜单 标签 -->
    <div class="secondary-box-two" v-if="secondLableShow">
      <div class="searchBox">
        <el-input class="searchBox_input" size="mini" placeholder="请输入关键字搜索" prefix-icon="el-icon-search" clearable
          v-model="searchResultOnelable" @input="searchGetMedicationLable">
        </el-input>
      </div>
      <div class="box_item">
        <el-scrollbar
          style="height:100%">
          <div class="message-item-box">
            <div class="message-content-box">
              <span :class="indexs == 0 ? 'curOne-sign' : 'curOne-sign'" v-for="(el,indexs) in drugListLable" :key="indexs"
                draggable @dragstart="(e)=>{dragstart(e,el)}">{{el.fieldName}}</span>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <!-- <div class="pagination">
        <el-pagination small background @size-change="handleSizeChangeLable" @current-change="handleCurrentChangeLable"
          :current-page.sync="searchFormLable.current" :page-size="searchFormLable.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalLable">
        </el-pagination>
      </div> -->
    </div>
    <!-- 右侧菜单身份信息 -->
    <div class="secondary-box-one" :style="{top:distanceTop}" v-if="identityInformationShow">
      <div class="searchBox">
        <el-input class="searchBox_input" @input="searchIdentity" v-model="Identity" size="mini" placeholder="请输入关键字搜索"
          @clear="clearInfoidentity" prefix-icon="el-icon-search" clearable>
        </el-input>
      </div>
      <div class="box_item">
        <el-scrollbar style="height:100%">
          <div class="message-item-box">
            <div class="message-content-box">
              <span :class="indexs == 0 ? 'curOne-sign' : 'curOne-sign'" v-for="(el,indexs) in identityInformationList"
                :key="indexs" draggable @dragstart="(e)=>{dragstart(e,el)}">{{el.fieldName}}</span>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <!-- 右侧二级子菜单 -->
    <div class="secondary-box" v-if="secondMenuShow">
      <div class="message-item-box-title">
        <span class="message-item-box-name">二级类目</span>
        <div class="message-item-box-text">
          <el-form :inline="true" class="demo-form-inline serchInp" size="mini">
            <el-form-item>
              <el-select clearable class="serchInp" v-model="serviceCode" @change="secondLevelChange" filterable
                placeholder="请输入关键词搜索二级类目">
                <el-option v-for="(item,index) in secondLevelCheckoutList" :key="index" :label="item.categoryName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="search-box">
        <el-form :inline="true" class="demo-form-inline" size="mini">
          <el-form-item>
            <el-input placeholder="请输入关键字搜索三级类目" @input="serchThreeName" prefix-icon="el-icon-search" clearable
              v-model="orderNo">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="sendsBoxs">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="message-item-box" v-for="(item,index) in threeLevelCheckoutList" :key="index">
            <collapse :titleType="'subheading'" :titleName="item.name">
              <div class="message-content-box">
                <span :class="indexs == 0 ? 'curTwo-sign' : 'curTwo-sign'" v-for="(el,indexs) in item.children"
                  :key="indexs" draggable @dragstart="(e)=>{dragstart(e,el)}">{{el.fieldName}}</span>
              </div>
            </collapse>

          </div>
        </el-scrollbar>
      </div>

    </div>
  </div>
</template>

<script>
import collapse from "./components/Collapse";
import {
  api_disease_type,
  api_getDrugData,
  api_getNation,
  api_profession,
  api_manualLabour,
  listGroupByExamType,
  FindStandardCategoryByType,
  getInspectionInfoByTypeIdAndName,
  getStandardCategoryByTypeAndName,
  getTreatmentItemByTypeIdAndName,
  api_BloodType,
  api_PatientTypeEnum,
  PatientEmbryoNumberEnum,
  api_SexType,
  symptomList,
  queryTagList
} from "./api/index";
export default {
  components: {
    collapse
  },
  data() {
    return {
      navTabArr: [
        {
          name: "术语",
          miniTitle: "单个元素可拖拽至画布中"
        },
        {
          name: "组件",
          miniTitle: "单个元素可拖拽至画布中"
        }
      ],

      navIndex: 0,
      orderNo: "", //请输入关键词搜索
      serviceCode: "", //关键词二级类目
      activeNum: 0, //选中的下标
      topHeight: 0,
      heighNum0: "auto",
      //基础信息
      basicInformation: [
        {
          name: "医疗诊断",
          id: "j_0001",
          children: [
            {
              id: "y_10001",
              nodeType: 1,
              type: 1,
              fieldCode: 10001,
              fieldName: "主要诊断",
              fieldLabel: "",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "y_10002",
              nodeType: 1,
              type: 1,
              fieldCode: 10002,
              fieldName: "入院其他诊断",
              fieldLabel: "",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "y_10003",
              nodeType: 1,
              type: 1,
              fieldCode: 10003,
              fieldName: "入院次要诊断",
              fieldLabel: "",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "y_10004",
              nodeType: 1,
              type: 1,
              fieldCode: 10004,
              fieldName: "出院诊断",
              fieldLabel: "",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "y_10005",
              nodeType: 1,
              type: 1,
              fieldCode: 10005,
              fieldName: "门诊次要诊断",
              fieldLabel: "",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "y_10006",
              nodeType: 1,
              type: 1,
              fieldCode: 10006,
              fieldName: "门诊其他诊断",
              fieldLabel: "",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "y_10007",
              nodeType: 1,
              type: 2,
              fieldCode: 10007,
              fieldName: "打卡用药",
              fieldLabel: "",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "y_10008",
              nodeType: 1,
              type: 3,
              fieldCode: 10008,
              fieldName: "处方检验",
              fieldLabel: "",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "y_10009",
              nodeType: 1,
              type: 4,
              fieldCode: 10009,
              fieldName: "治疗方式",
              fieldLabel: "",
              fieldValue: "",
              isSlect: false
            }
          ]
        },
        {
          name: "身份信息",
          id: "j_0002",
          children: [
            {
              id: "s_20001",
              index: 1,
              nodeType: 1,
              fieldCode: 20001,
              fieldName: "民族",
              fieldLabel: "",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "s_20002",
              nodeType: 1,
              index: 2,
              fieldCode: 20002,
              fieldName: "患者状态",
              fieldLabel: "",
              fieldValue: "",
              isSlect: false
            },

            {
              id: "s_20003",
              nodeType: 1,
              index: 3,
              fieldCode: 20003,
              fieldName: "血型",
              fieldLabel: "",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "s_20004",
              nodeType: 1,
              index: 4,
              fieldCode: 20004,
              fieldName: "职业",
              fieldLabel: "",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "s_20005",
              nodeType: 1,
              index: 5,
              fieldCode: 20005,
              fieldName: "体力劳动等级",
              fieldLabel: "",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "y_50004",
              nodeType: 1,
              index: 6,
              fieldCode: 50004,
              fieldName: "胎数",
              fieldLabel: "胎数",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "y_50005",
              nodeType: 1,
              index: 7,
              fieldCode: 20006,
              fieldName: "性别",
              fieldLabel: "性别",
              fieldValue: "",
              isSlect: false
            }
          ]
        },
        {
          name: "生命特征",
          id: "j_0003",
          children: [
            {
              id: "s_30001",
              nodeType: 1,
              fieldCode: 30001,
              fieldName: "心率",
              fieldLabel: "心率",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "s_30002",
              nodeType: 1,
              fieldCode: 30002,
              fieldName: "呼吸",
              fieldLabel: "呼吸",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "s_30003",
              nodeType: 1,
              fieldCode: 30003,
              fieldName: "血压-收缩压	",
              fieldLabel: "血压-收缩压	",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "s_30004",
              nodeType: 1,
              fieldCode: 30004,
              fieldName: "血压-舒张压",
              fieldLabel: "血压-舒张压",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "s_30005",
              nodeType: 1,
              fieldCode: 30005,
              fieldName: "空腹血糖",
              fieldLabel: "空腹血糖	",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "s_30006",
              nodeType: 1,
              fieldCode: 30006,
              fieldName: "血氧",
              fieldLabel: "血氧",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "s_30007",
              nodeType: 1,
              fieldCode: 30007,
              fieldName: "餐后血糖",
              fieldLabel: "餐后血糖",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "s_30008",
              nodeType: 1,
              fieldCode: 30008,
              fieldName: "身高",
              fieldLabel: "身高",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "s_30009",
              nodeType: 1,
              fieldCode: 30009,
              fieldName: "体重",
              fieldLabel: "体重",
              fieldValue: "",
              isSlect: false
            },
            // {
            //   id: "s_30010",
            //   nodeType: 1,
            //   fieldCode: 30010,
            //   fieldName: "腰围",
            //   fieldLabel: "腰围",
            //   fieldValue: "",
            //   isSlect: false
            // },
            // {
            //   id: "s_30011",
            //   nodeType: 1,
            //   fieldCode: 30011,
            //   fieldName: "臀围",
            //   fieldLabel: "臀围",
            //   fieldValue: "",
            //   isSlect: false
            // },
            {
              id: "s_30012",
              nodeType: 1,
              fieldCode: 30012,
              fieldName: "年龄",
              fieldLabel: "年龄",
              fieldValue: "",
              isSlect: false
            }
          ]
        },
        {
          name: "症状",
          id: "j_0006",
          children: [
            {
              id: "s_10010",
              nodeType: 1,
              fieldCode: 10010,
              fieldName: "症状",
              fieldLabel: "症状",
              fieldValue: "",
              isSlect: false
            },
          ]
        },
        {
          name: "标签",
          id: "j_0006",
          children: [
            {
              id: "s_10011",
              nodeType: 1,
              fieldCode: 10011,
              fieldName: "标签",
              fieldLabel: "标签",
              fieldValue: "",
              isSlect: false
            },
          ]
        },
        {
          name: "医疗信息",
          id: "j_0004",
          children: [
            {
              id: "y_40001",
              nodeType: 1,
              fieldCode: 40001,
              fieldName: "最近一次住院天数",
              fieldLabel: "最近一次住院天数",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "y_40002",
              nodeType: 1,
              fieldCode: 40002,
              fieldName: "最近出院时间",
              fieldLabel: "最近出院时间",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "y_40003",
              nodeType: 1,
              fieldCode: 40003,
              fieldName: "最近入院时间",
              fieldLabel: "最近入院时间",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "y_40004",
              nodeType: 1,
              fieldCode: 40004,
              fieldName: "近期是否门诊就诊",
              fieldLabel: "近期是否门诊就诊",
              fieldValue: 1,
              isSlect: false
            },
            {
              id: "y_40005",
              nodeType: 1,
              fieldCode: 40005,
              fieldName: "门诊就诊时间",
              fieldLabel: "门诊就诊时间",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "y_40006",
              nodeType: 1,
              fieldCode: 40006,
              fieldName: "在院期间是否进行手术",
              fieldLabel: "在院期间是否进行手术",
              fieldValue: 1,
              isSlect: false
            },
            {
              id: "y_40007",
              nodeType: 1,
              fieldCode: 40007,
              fieldName: "最近手术时间",
              fieldLabel: "最近手术时间",
              fieldValue: "",
              isSlect: false
            }
          ]
        },
        {
          name: "孕产信息",
          id: "j_0005",
          children: [
            {
              id: "y_50001",
              nodeType: 1,
              fieldCode: 50001,
              fieldName: "是否孕产妇",
              fieldLabel: "是否孕产妇",
              fieldValue: 1,
              isSlect: false
            },
            {
              id: "y_50002",
              nodeType: 1,
              fieldCode: 50002,
              fieldName: "末次月经",
              fieldLabel: "末次月经",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "y_50003",
              nodeType: 1,
              fieldCode: 50003,
              fieldName: "预产期",
              fieldLabel: "预产期",
              fieldValue: "",
              isSlect: false
            },
            {
              id: "y_50005",
              nodeType: 1,
              fieldCode: 50005,
              fieldName: "孕前体重",
              fieldLabel: "孕前体重",
              fieldValue: "",
              isSlect: false
            }
            // {
            //   id: "y_50006",
            //   nodeType: 1,
            //   fieldCode: 50006,
            //   fieldName: "是否哺乳期",
            //   fieldLabel: "是否哺乳期",
            //   fieldValue: "",
            //   isSlect: false
            // }
          ]
        }
      ],
      //问卷
      questionnaire: [],
      //条件判断
      conditionArr: [
        {
          name: "时间类型",
          conditionType: 1,
          nodeType: 3,
          id: "t_0001",
          children: [
            {
              id: "t_1_001",
              valueUnit: "",
              operator: "",
              value: "",
              showType: "input"
            },
            {
              id: "t_1_002",
              valueUnit: "1",
              operator: "",
              value: "",
              showType: "select_time"
            },
            {
              id: "t_1_003",
              valueUnit: "",
              operator: "1",
              value: "",
              showType: "select_time_direction"
            }
          ]
        },
        {
          name: "定量类型",
          conditionType: 2,
          nodeType: 3,
          id: "t_0002",
          children: [
            {
              id: "t_2_001",
              valueUnit: "",
              operator: "1",
              value: "",
              showType: "select_greater"
            },
            {
              id: "t_2_002",
              valueUnit: "",
              operator: "",
              value: "",
              showType: "input"
            },
            {
              id: "t_2_003",
              valueUnit: "1",
              operator: "",
              value: "",
              showType: "select_time_longness"
            }
          ]
        },
        {
          name: "定性类型",
          conditionType: 3,
          nodeType: 3,
          id: "t_0003",
          children: [
            {
              id: "t_3_001",
              valueUnit: "",
              operator: "3",
              value: "+",
              showType: "select_symbol"
            }
          ]
        },
        {
          name: "绝对类型",
          conditionType: 4,
          nodeType: 3,
          id: "t_0004",
          children: [
            {
              id: "t_4_001",
              valueUnit: "",
              operator: "3",
              value: "",
              showType: "select_bool"
            }
          ]
        },
        {
          name: "最后次数",
          nodeType: 3,
          id: "t_0005",
          conditionType: 5,
          children: [
            {
              id: "t_5_001",
              valueUnit: "",
              operator: "1",
              value: "最后",
              showType: "button_last"
            },
            {
              id: "t_5_002",
              valueUnit: "",
              operator: "",
              value: "1",
              showType: "select_number"
            },
            {
              id: "t_5_003",
              valueUnit: "",
              operator: "",
              value: "次",
              showType: "button"
            }
          ]
        },
        {
          name: "间隔次数",
          nodeType: 3,
          id: "t_0005",
          conditionType: 6,
          children: [
            {
              id: "t_6_001",
              valueUnit: "",
              operator: "1",
              value: "",
              showType: "select_greater"
            },
            {
              id: "t_6_002",
              valueUnit: "",
              operator: "",
              value: "1",
              showType: "select_number"
            },
            {
              id: "t_6_003",
              valueUnit: "",
              operator: "",
              value: "次",
              showType: "button"
            }
          ]
        },
        {
          name: "持续时间",
          nodeType: 3,
          conditionType: 7,
          id: "t_0006",
          children: [
            {
              id: "t_7_001",
              valueUnit: "",
              operator: "",
              value: "",
              showType: "input"
            },
            {
              id: "t_7_002",
              valueUnit: "1",
              operator: "",
              value: "",
              showType: "select_time"
            }
          ]
        },
        {
          name: "问卷分值",
          nodeType: 3,
          conditionType: 8,
          id: "t_0007",
          children: [
            {
              id: "t_7_001",
              valueUnit: "",
              operator: "1",
              value: "",
              showType: "select_greater"
            },
            {
              id: "t_7_002",
              valueUnit: "",
              operator: "",
              value: "",
              showType: "input_number"
            },
            {
              id: "t_7_003",
              valueUnit: "1",
              operator: "",
              value: "",
              showType: "select_button"
            }
          ]
        }
      ],
      historyBasicInformation: [],
      historyQuestionnaire: [],
      searchResultInfo: "",
      searchResultQuestionnaire: "",
      DiseaseTypeList: [], //疾病列表
      secondLevelShow: false, //二级弹框是否显示
      secondLevelDrugShow: false, //打卡用药
      secondSymptomShow: false, //症状
      secondLableShow: false, //标签
      levelShow: false, //三级弹框是否显示
      searchResultOne: "", //二级弹框搜索值
      searchResultOneSymptom: "", //二级弹框搜索值症状      
      searchResultOnelable: "", //二级弹框搜索值标签      
      searchForm: {
        size: 50,
        current: 1,
        name: "",
        isEnable: false
      },
      searchFormSymptom:{
        size: 50,
        current: 1,
        name: "",
        enabled:true
        // isEnable: false
      },
      searchFormLable:{
        // size: 50,
        // current: 1,
        tagName: "",
        enabled:true
        // isEnable: false
      },
      total: 0,
      totalSymptom: 0,
      totalLable: 0,
      drugList: [],
      drugListSymptom: [],
      drugListLable: [],
      illnessType: "",
      identityInformationShow: false, //身份信息二次菜单是否显示
      identityInformationList: [],
      Identity: "",
      questionnaireName: "", //问卷名称
      questionnaireList: [],
      secondMenuShow: false,
      temp: {
        categoryName: "",
        parentId: 0,
        type: 2
      },
      temp1: {
        categoryName: "",
        type: 4
      },
      secondLevelCheckoutList: [], //检验二级数据
      threeLevelCheckoutList: [],
      threeType: "",
      fieldCode: "",
      pharmacyName: "",
      pharmacyCode: "",
      distanceTop: "150px"
    };
  },
  mounted() {
    this.historyBasicInformation = this.basicInformation;
    this.historyQuestionnaire = this.questionnaire;
    this.getlistGroupByExamType();
  },
  methods: {
    dragstart(e, user) {
      //对接完数据后在这里处理最终需要拖入的数据格式,如下obj：结合接受值修改
      // let obj = {
      //   nodeType: 1,
      //   fieldCode: "根据选的内容动态去拿",
      //   fieldName: "根据选的内容动态去拿", //根据选的内容动态去拿
      //   fieldLabel: "根据选的内容动态去拿",
      //   fieldValue: "根据选的内容动态去拿"
      // };
      if (user.nodeType == 3) {
        for (let i = 0; i < user.children.length; i++) {
          if (user.children[i].showType == "input") {
            if (!user.children[i].value) {
              this.$message.error("请输入数值，再拖动");
              return false;
            }
          }
        }
      }
      e.dataTransfer.setData("user", JSON.stringify(user)); //obj
    },
    //术语和组件切换
    navTab(index) {
      this.navIndex = index;
    },
    slideFun(index, indexs, item, items) {
      this.basicInformation.forEach((ele, i) => {
        if (i != index) {
          ele.children.forEach(els => {
            els.isSlect = false;
          });
        }
      });
      this.basicInformation[index].children.forEach(i => {
        if (
          i.isSlect !== this.basicInformation[index].children[indexs].isSlect
        ) {
          i.isSlect = false;
        }
      });
      item.isSlect = !item.isSlect;
      this.serviceCode = "";
      this.orderNo = "";
      this.fieldCode = item.fieldCode;
      //请求接口返回等二级数据
      //医疗诊断的前6个，调取病种接口
      console.log(item,"item");
      if (items.name == "医疗诊断" && item.type == 1) {
        this.getDiseaseType(item.fieldName, item.fieldCode);
        if (item.isSlect) {
          this.secondLevelShow = true;
        } else {
          this.secondLevelShow = false;
        }
        this.secondLevelDrugShow = false;
        this.identityInformationShow = false;
        this.secondSymptomShow = false;
        this.secondLableShow = false;
        this.secondMenuShow = false;
      } else if (items.name == "医疗诊断" && item.type == 2) {
        //打卡用药
        this.getMedication(item.fieldName, item.fieldCode);
        this.pharmacyName = item.fieldName;
        this.pharmacyCode = item.fieldCode;
        if (item.isSlect) {
          this.secondLevelDrugShow = true;
        } else {
          this.secondLevelDrugShow = false;
        }
        this.secondLevelShow = false;
        this.identityInformationShow = false;
        this.secondMenuShow = false;
        this.secondSymptomShow = false;
        this.secondLableShow = false;
      } else if (items.name == "医疗诊断" && item.type == 3) {
        //检验
        this.threeType = "检验";
        this.getFindStandardCategoryByType(item.fieldName);
        this.getInspectionInfoByTypeIdAndNames("", "", item.fieldCode);
        if (item.isSlect) {
          this.secondMenuShow = true;
        } else {
          this.secondMenuShow = false;
        }
        this.secondLevelShow = false;
        this.identityInformationShow = false;
        this.secondLevelDrugShow = false;
        this.secondSymptomShow = false;
        this.secondLableShow = false;
      } else if (items.name == "医疗诊断" && item.type == 4) {
        //治疗
        this.threeType = "治疗";
        this.getTherapyMethod(item.fieldName);
        this.getInspectionInfoByTypeIdAndNames("", "", item.fieldCode);
        if (item.isSlect) {
          this.secondMenuShow = true;
        } else {
          this.secondMenuShow = false;
        }
        this.secondLevelShow = false;
        this.identityInformationShow = false;
        this.secondLevelDrugShow = false;
        this.secondSymptomShow = false;
        this.secondLableShow = false;
      } else if (items.name == "症状") {
        //症状
        this.getMedicationSymptom(item.fieldName, item.fieldCode);
        this.pharmacyName = item.fieldName;
        this.pharmacyCode = item.fieldCode;
        if (item.isSlect) {
          this.secondSymptomShow = true;
        } else {
          this.secondSymptomShow = false;
        }
        this.secondLevelShow = false;
        this.identityInformationShow = false;
        this.secondMenuShow = false;
        this.secondLableShow = false;
      } else if (items.name == "标签") {
        //标签
        this.getMedicationLable(item.fieldName, item.fieldCode);
        this.pharmacyName = item.fieldName;
        this.pharmacyCode = item.fieldCode;
        if (item.isSlect) {
          this.secondLableShow = true;
        } else {
          this.secondLableShow = false;
        }
        this.secondLevelShow = false;
        this.identityInformationShow = false;
        this.secondMenuShow = false;
        this.secondSymptomShow = false;
      } else if (items.name == "身份信息") {
        //身份信息--民族
        //民族
        this.Identity = "";
        if (item.index == 1) {
          this.getNation(item.fieldName, item.fieldCode);
        } else if (item.index == 2) {
          //患者状态
          this.getPatientTypeEnum(item.fieldName, item.fieldCode);
        } else if (item.index == 3) {
          //血型
          this.getBloodType(item.fieldName, item.fieldCode);
        } else if (item.index == 4) {
          //职业
          this.getProfession(item.fieldName, item.fieldCode);
        } else if (item.index == 5) {
          //体力劳动
          this.getManualLabour(item.fieldName, item.fieldCode);
        } else if (item.index == 6) {
          //胎数
          this.getFetusesNum(item.fieldName, item.fieldCode);
        }else if (item.index == 7) {
          //性别
          this.getSexArr(item.fieldName, item.fieldCode);
        }

        if (item.isSlect) {
          this.identityInformationShow = true;
          this.distanceTop = "310px";
        } else {
          this.identityInformationShow = false;
        }
        this.secondLevelShow = false;
        this.secondLevelDrugShow = false;
        this.secondMenuShow = false;
        this.secondSymptomShow = false;
        this.secondLableShow = false;
      } else {
        this.secondLevelShow = false;
        this.secondLevelDrugShow = false;
        this.identityInformationShow = false;
        this.secondMenuShow = false;
        this.secondSymptomShow = false;
        this.secondLableShow = false;
      }
      this.illnessType = "";
    },

    slideFun1(index, indexs, item) {
      this.questionnaire[index].children.forEach(i => {
        if (i.isSlect !== this.questionnaire[index].children[indexs].isSlect) {
          i.isSlect = false;
        }
      });
      item.isSlect = !item.isSlect;
    },
    /**
     * @description: 模糊查询基本信息
     * @param {*} val 实时搜索内容
     * @return {*} 新的返回值
     */

    searchChange(val) {
      if (!val) {
        this.basicInformation = this.historyBasicInformation;
        return;
      }
      this.basicInformation.forEach(ele => {
        ele.children.forEach(els => {
          els.isSlect = false;
        });
      });
      this.secondLevelShow = false;
      this.secondLevelDrugShow = false;
      this.identityInformationShow = false;
      this.secondMenuShow = false;
      let newMap = [];
      this.historyBasicInformation.forEach(item => {
        let newArrs = this.fuzzyQuery(item.children, val);
        if (newArrs.length > 0) {
          let json = {};
          json.name = item.name;
          json.num = item.num;
          json.children = newArrs;
          newMap.push(json);
          this.basicInformation = newMap;
        } else {
          this.basicInformation = newMap;
        }
      });
      if (newMap.length == 0) {
        this.basicInformation = [];
      }
    },
    /**
     * @description: 模糊查询病种
     * @param {*} val 实时搜索内容
     * @return {*} 新的返回值
     */
    searchFilter(val) {
      if (!val) {
        this.DiseaseTypeList = this.DiseaseTypeListOld;
        return;
      }
      var reg = new RegExp(val);
      let list = this.DiseaseTypeListOld;
      var arr = [];
      for (var i = 0; i < list.length; i++) {
        if (reg.test(list[i].fieldName)) {
          arr.push(list[i]);
        }
      }
      this.DiseaseTypeList = arr;
    },
    /**
     * @description: 模糊查询身份信息
     * @param {*} val 实时搜索内容
     * @return {*} 新的返回值
     */
    searchIdentity(val) {
      if (!val) {
        this.identityInformationList = this.identityInformationListOld;
        return;
      }
      var reg = new RegExp(val);
      let list = this.identityInformationListOld;
      var arr = [];
      for (var i = 0; i < list.length; i++) {
        if (reg.test(list[i].fieldName)) {
          arr.push(list[i]);
        }
      }
      this.identityInformationList = arr;
    },
    /**
     * @description: 模糊查询问卷
     * @param {*} val 实时搜索内容
     * @return {*} 新的返回值
     */
    searchChangeQuest(val) {
      this.getlistGroupByExamType();
    },
    /**
     * @description: 检验二级数据变化请求三级
     * @param {*} val 实时搜索内容
     * @return {*} 新的返回值
     */
    secondLevelChange(val) {
      this.getInspectionInfoByTypeIdAndNames(val, "", this.fieldCode);
      this.orderNo = "";
    },
    /**
     * @description: 检验搜索三级
     * @param {*} val 实时搜索内容
     * @return {*} 新的返回值
     */
    serchThreeName(val) {
      this.getInspectionInfoByTypeIdAndNames(
        this.serviceCode,
        val,
        this.fieldCode
      );
    },
    /**
     * @description: 清除基础信息搜索内容
     * @param {*}
     * @return {*}
     */

    clearInfo() {
      this.basicInformation = this.historyBasicInformation;
    },
    clearInfoIllness() {
      this.DiseaseTypeList = this.DiseaseTypeListOld;
    },
    clearInfoidentity() {},
    /**
     * 使用test方法实现模糊查询
     * @param  {Array}  list     原数组
     * @param  {String} keyWord  查询的关键词
     * @return {Array}           查询的结果
     */
    fuzzyQuery(list, keyWord) {
      var reg = new RegExp(keyWord);
      var arr = [];
      for (var i = 0; i < list.length; i++) {
        if (reg.test(list[i].fieldName)) {
          arr.push(list[i]);
        }
      }
      return arr;
    },
    /**
     * 获取疾病类型
     * @param  {Array}
     * @param  {String}
     * @return {Array} 查询的结果
     */

    getDiseaseType(name, code) {
      api_disease_type().then(res => {
        // this.DiseaseTypeList = res.data ? res.data : [];
        if (res.data && res.data.length > 0) {
          this.DiseaseTypeList = res.data.map(item => {
            let json = {};
            json.id = item.id;
            json.nodeType = 1;
            json.fieldCode = code;
            json.fieldName = item.suborderName;
            json.fieldLabel = `${name}:${item.suborderName}`;
            json.fieldValue = item.id;
            json.isSlect = false;
            return json;
          });
          this.DiseaseTypeListOld = this.DiseaseTypeList;
        }
      });
    },
    searchGetMedication() {
      this.getMedication(this.pharmacyName, this.pharmacyCode);
    },
    /**
     * @description:  获取打卡用药数据
     * @param {*}
     * @return {*}
     */
    getMedication(name, code) {
      this.searchForm.name = this.searchResultOne;
      api_getDrugData(this.searchForm).then(res => {
        this.total = res.data.total;
        this.drugList = res.data.records.map(item => {
          let json = {};
          json.id = item.id;
          json.nodeType = 1;
          json.fieldCode = code;
          json.fieldName = item.name;
          json.fieldLabel = `${name}:${item.name}`;
          json.fieldValue = item.id;
          json.isSlect = false;
          return json;
        });
      });
    },
    // 症状
    searchGetMedicationSymptom() {
      this.getMedicationSymptom(this.pharmacyName, this.pharmacyCode);
    },
    // 标签
    searchGetMedicationLable() {
      this.getMedicationLable(this.pharmacyName, this.pharmacyCode);
    },
    
    /**
     * @description:  获取症状数据
     * @param {*}
     * @return {*}
     */
     getMedicationSymptom(name, code) {
      this.searchFormSymptom.name = this.searchResultOneSymptom;
      symptomList(this.searchFormSymptom).then(res => {
        this.totalSymptom = res.data.total;
        this.drugListSymptom = res.data.records.map(item => {
          let json = {};
          json.id = item.id;
          json.nodeType = 1;
          json.fieldCode = code;
          json.fieldName = item.name;
          json.fieldLabel = `${name}:${item.name}`;
          json.fieldValue = item.id;
          json.isSlect = false;
          return json;
        });
        console.log(this.drugListSymptom,"this.drugListSymptom");
      });
    },
    /**
     * @description:  获取标签数据
     * @param {*}
     * @return {*}
     */
     getMedicationLable(name, code) {
      this.searchFormLable.tagName = this.searchResultOnelable;
      queryTagList(this.searchFormLable).then(res => {
      //   this.searchFormLable.name = this.searchResultOnelable;
      // symptomList(this.searchFormSymptom).then(res => {
        // this.totalLable = res.data.total;
        this.drugListLable = res.data.map(item => {
          let json = {};
          json.id = item.tagId;
          json.nodeType = 1;
          json.fieldCode = code;
          json.fieldName = item.tagName;
          // json.fieldLabel = `${name}:${item.name}`;
          json.fieldLabel = `${name}:${item.tagName}`;
          json.fieldValue = item.tagId;
          json.isSlect = false;
          return json;
        });
        console.log(this.drugListLable,"this.drugListLable");
      });
    },
    /**
     * @description:  获取民族数据
     * @param {*}
     * @return {*}
     */
    getNation(name, code) {
      this.identityInformationList = [];
      api_getNation().then(res => {
        this.identityInformationList = res.data.map(item => {
          let json = {};
          json.id = item.id;
          json.nodeType = 1;
          json.fieldCode = code;
          json.fieldName = item.name;
          json.fieldLabel = `${name}:${item.name}`;
          json.fieldValue = item.id;
          json.isSlect = false;
          return json;
        });
        this.identityInformationListOld = this.identityInformationList;
      });
    },
    /**
     * @description:  获取职业数据
     * @param {*}
     * @return {*}
     */
    getProfession(name, code) {
      this.identityInformationList = [];
      api_profession().then(res => {
        this.identityInformationList = res.data.map(item => {
          let json = {};
          json.id = item.id;
          json.nodeType = 1;
          json.fieldCode = code;
          json.fieldName = item.name;
          json.fieldLabel = `${name}:${item.name}`;
          json.fieldValue = item.id;
          json.isSlect = false;
          return json;
        });
        this.identityInformationListOld = this.identityInformationList;
      });
    },
    /**
     * @description:  获取体力劳动等级
     * @param {*}
     * @return {*}
     */
    getManualLabour(name, code) {
      this.identityInformationList = [];
      api_manualLabour().then(res => {
        this.identityInformationList = res.data.map(item => {
          let json = {};
          json.id = item.id;
          json.nodeType = 1;
          json.fieldCode = code;
          json.fieldName = item.name;
          json.fieldLabel = `${name}:${item.name}`;
          json.fieldValue = item.code;
          json.isSlect = false;
          return json;
        });
        this.identityInformationListOld = this.identityInformationList;
      });
    },
    /**
     * @description:  胎数
     * @param {*}
     * @return {*}
     */
    getFetusesNum(name, code) {
      this.identityInformationList = [];
      PatientEmbryoNumberEnum().then(res => {
        this.identityInformationList = res.data.map(item => {
          let json = {};
          json.id = item.id;
          json.nodeType = 1;
          json.fieldCode = code;
          json.fieldName = item.name;
          json.fieldLabel = `${name}:${item.name}`;
          json.fieldValue = item.code;
          json.isSlect = false;
          return json;
        });
        this.identityInformationListOld = this.identityInformationList;
      });
    },
    /**
     * @description:  获取性别
     * @param {*}
     * @return {*}
     */
    
     getSexArr(name, code) {
      this.identityInformationList = [];
      api_SexType().then(res => {
        this.identityInformationList = res.data.map(item => {
          let json = {};
          json.id = item.id;
          json.nodeType = 1;
          json.fieldCode = code;
          json.fieldName = item.name;
          json.fieldLabel = `${name}:${item.name}`;
          json.fieldValue = item.code;
          json.isSlect = false;
          return json;
        });
        this.identityInformationListOld = this.identityInformationList;
      });
    },
    /**
     * @description:  获取血型
     * @param {*}
     * @return {*}
     */
    getBloodType(name, code) {
      this.identityInformationList = [];
      api_BloodType().then(res => {
        this.identityInformationList = res.data.map(item => {
          let json = {};
          json.id = item.code;
          json.nodeType = 1;
          json.fieldCode = code;
          json.fieldName = item.name;
          json.fieldLabel = `${name}:${item.name}`;
          json.fieldValue = item.code;
          json.isSlect = false;
          return json;
        });
        this.identityInformationListOld = this.identityInformationList;
      });
    },
    /**
     * @description:  获取患者状态
     * @param {*}
     * @return {*}
     */
    getPatientTypeEnum(name, code) {
      this.identityInformationList = [];
      api_PatientTypeEnum().then(res => {
        this.identityInformationList = res.data.map(item => {
          let json = {};
          json.id = item.id;
          json.nodeType = 1;
          json.fieldCode = code;
          json.fieldName = item.name;
          json.fieldLabel = `${name}:${item.name}`;
          json.fieldValue = item.code;
          json.isSlect = false;
          return json;
        });
        this.identityInformationListOld = this.identityInformationList;
      });
    },
    /**
     * @description:  获取问卷
     * @param {*} title 问卷名称
     * @return {*}
     */
    getlistGroupByExamType() {
      listGroupByExamType({
        title: this.questionnaireName,
        countScore: true,
        draft: false
      }).then(res => {
        let newArr = [];
        for (let key in res.data) {
          let children = res.data[key].map(item => {
            let json = {};
            json.id = item.id;
            json.nodeType = 1;
            json.fieldCode = "60001";
            json.fieldName = item.title;
            json.fieldLabel = "问卷:" + item.title;
            json.fieldValue = item.id;
            json.isSlect = false;
            return json;
          });
          let newJson = {
            name: key,
            children: children
          };
          newArr.push(newJson);
        }

        this.questionnaire = newArr;
        // this.questionnaireList=res.data.map(item=>{
        // })
      });
    },

    /**
     * @description:  获取处方检验二级数据
     * @param {*}
     * @return {*}
     */
    getFindStandardCategoryByType() {
      FindStandardCategoryByType(this.temp).then(res => {
        this.secondLevelCheckoutList = res.data;
      });
    },
    /**
     * @description:  获取 处方检验，治疗三级数据
     * @param {*}
     * @return {*}
     */
    getInspectionInfoByTypeIdAndNames(id, name, code) {
      if (this.threeType == "检验") {
        getInspectionInfoByTypeIdAndName({ id, name }).then(res => {
          this.threeLevelCheckoutList = res.data.map(item => {
            let newJson = {};
            newJson.name = item.title;
            newJson.children = item.inspectionInfoDecisionTreeVOList.map(
              items => {
                let json = {};
                json.id = items.id;
                json.nodeType = 1;
                json.fieldCode = code;
                json.fieldName = items.name;
                json.fieldLabel = "处方检验:" + items.name;
                json.fieldValue = items.id;
                json.isSlect = false;
                return json;
              }
            );
            return newJson;
          });
        });
      } else if (this.threeType == "治疗") {
        getTreatmentItemByTypeIdAndName({ id, name, code }).then(res => {
          this.threeLevelCheckoutList = res.data.map(item => {
            let newJson = {};
            newJson.name = item.title;
            newJson.children = item.treatmentItemVOList.map(items => {
              let json = {};
              json.id = items.id;
              json.nodeType = 1;
              json.fieldCode = code;
              json.fieldName = items.name;
              json.fieldLabel = "治疗方式:" + items.name;
              json.fieldValue = items.id;
              json.isSlect = false;
              return json;
            });
            return newJson;
          });
        });
      }
    },

    // handleJson(name, item) {
    //   let json = {};
    //   json.id = item.id ? item.id : item.code;
    //   json.nodeType = 1;
    //   json.fieldCode = item.id ? item.id : item.code;
    //   json.fieldName = item.title;
    //   json.fieldLabel = name + item.title;
    //   json.fieldValue = "";
    //   json.isSlect = false;
    //   return json;
    // },
    /**
     * @description:  获取治疗方式
     * @param {*}
     * @return {*}
     */
    getTherapyMethod() {
      getStandardCategoryByTypeAndName(this.temp1).then(res => {
        this.secondLevelCheckoutList = res.data;
      });
    },
    /**
     * @description: 限制input框输入大小
     * @param {*}
     * @return {*}
     */
    handleInput2(e) {
      e.target.value = e.target.value > 999.9 ? 999.9 : e.target.value;
    },
    /**
     * @description:  分页触发事件
     * @param {*}
     * @return {*}
     */
    handleSizeChange(val) {
      this.searchForm.size = val;
      this.getMedication(this.pharmacyName, this.pharmacyCode);
    },
    handleCurrentChange(val) {
      this.searchForm.current = val;
      this.getMedication(this.pharmacyName, this.pharmacyCode);
    },
    /**
     * @description:  症状分页触发事件
     * @param {*}
     * @return {*}
     */
    handleSizeChangeSymptom(val) {
      this.searchForm.size = val;
      this.getMedicationSymptom(this.pharmacyName, this.pharmacyCode);
    },
    handleCurrentChangeSymptom(val) {
      this.searchForm.current = val;
      this.getMedicationSymptom(this.pharmacyName, this.pharmacyCode);
    },
    /**
     * @description:  标签分页触发事件
     * @param {*}
     * @return {*}
     */
     handleSizeChangeLable(val) {
      this.searchForm.size = val;
      this.getMedicationLable(this.pharmacyName, this.pharmacyCode);
    },
    handleCurrentChangeLable(val) {
      this.searchForm.current = val;
      this.getMedicationLable(this.pharmacyName, this.pharmacyCode);
    }
  }
};
</script>

<style lang="less" scoped>
* {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
@import "./leftModule";
</style>